import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';

import { HttpClientService } from 'app/core/services/http-client.service';

import { EndpointsConstants } from 'app/shared/constants/endpoints.constants';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  token: string;
  currentUser;
  url: string;

  constructor(
    private router: Router,
    private httpService: HttpClientService
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  }

  signupUser(email: string, password: string) {
    // your code for signing up the new user
  }


  logout() {
    this.token = null;
    this.currentUser = null;

    localStorage.removeItem('currentUser');
    localStorage.removeItem('token');
    localStorage.removeItem('view');
    localStorage.removeItem('ganttFilters');

    this.router.navigate(['/ingresar']);
  }

  login(email: string, password: string): Observable<boolean> {
    return new Observable<boolean>(observer => {
      this.httpService.post(EndpointsConstants.admin.login, { email, password }).subscribe(
        response => {
          const currentUser = response['data'].admin;
          const token = response['data'].token;
          localStorage.setItem('currentUser', JSON.stringify(currentUser));
          localStorage.setItem('token', token);
          observer.next(true);
        },
        error => {
          observer.next(false);
        }
      );
    });
  }

  getToken() {
    this.token = localStorage.getItem('token');
    return this.token;
  }

  isAuthenticated(route, state) {
    const currentUser = this.getCurrentUser();

    if (!currentUser && state.url !== '/ingresar') {
      this.router.navigate(['/ingresar']);
      return false;
    }

    return true;
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('currentUser'));
  }
}
